/* eslint-disable max-len */
import React, { FC } from 'react';

export const MyAccountMyActivityIcon: FC<{ className?: string }> = ({ className }) => {
  return (
    <svg
      width="84"
      height="85"
      viewBox="0 0 84 85"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M42 0C18.8416 0 0 18.9911 0 42.3333C0 65.6755 18.8416 84.6667 42 84.6667C65.1584 84.6667 84 65.6755 84 42.3333C84 18.9911 65.1584 0 42 0ZM42 76.2C23.4742 76.2 8.4 61.0061 8.4 42.3333C8.4 23.6605 23.4742 8.46667 42 8.46667C60.5258 8.46667 75.6 23.6605 75.6 42.3333C75.6 61.0061 60.5258 76.2 42 76.2Z"
        fill="var(--primary-900)"
      />
      <path
        d="M44.0996 33.8668H39.8996C38.7232 33.8668 37.602 34.3622 36.8087 35.2343C36.0145 36.1064 35.6155 37.2751 35.7127 38.4514L37.8131 63.8514C37.9935 66.0439 39.8127 67.7335 42.001 67.7335C44.1893 67.7335 46.0038 66.0439 46.1888 63.8514L48.2893 38.4514C48.3856 37.2704 47.9913 36.1064 47.1933 35.2343C46.3991 34.3622 45.2778 33.8668 44.1024 33.8668H44.0996Z"
        fill="var(--primary-900)"
      />
      <path
        d="M38.1233 22.7839C38.2279 23.0419 38.3587 23.2877 38.5101 23.5166C38.6615 23.7492 38.8381 23.9649 39.0305 24.1598C39.223 24.3548 39.4379 24.5328 39.6687 24.6844C39.8958 24.837 40.1387 24.9679 40.3957 25.0743C40.6479 25.1798 40.9124 25.2646 41.1815 25.3154C41.4506 25.37 41.7271 25.4002 42.0009 25.4002C43.1053 25.4002 44.1892 24.9472 44.9703 24.1598C45.1638 23.9649 45.3403 23.7492 45.4908 23.5166C45.6421 23.2877 45.772 23.0429 45.8776 22.7839C45.9823 22.5296 46.0664 22.2631 46.1168 21.9918C46.171 21.7206 46.2009 21.4418 46.2009 21.1659C46.2009 20.89 46.1719 20.6112 46.1168 20.34C46.0664 20.0687 45.9823 19.8022 45.8776 19.5479C45.773 19.2899 45.6421 19.0441 45.4908 18.8152C45.3394 18.5826 45.1628 18.3669 44.9703 18.172C43.9958 17.1897 42.5466 16.7367 41.1824 17.0117C40.9133 17.0663 40.6489 17.1511 40.3966 17.2575C40.1406 17.363 39.8967 17.4901 39.6696 17.6474C39.4389 17.8 39.2249 17.978 39.0315 18.172C38.8381 18.366 38.6615 18.5826 38.511 18.8152C38.3597 19.0441 38.2298 19.2889 38.1242 19.5479C38.0195 19.8022 37.9392 20.0687 37.885 20.34C37.8308 20.6112 37.8009 20.89 37.8009 21.1659C37.8009 21.4418 37.8299 21.7206 37.885 21.9918C37.9401 22.2631 38.0195 22.5296 38.1242 22.7839H38.1233Z"
        fill="var(--primary-900)"
      />
    </svg>
  );
};
